import { pagesPath } from "faqSrc/lib/$path";
import Link from "next/link";
import React, { VFC } from "react";
import styled from "styled-components";
import Image from "components/atoms/Image";
import { convertToLinkHref, externalLinkAttrs } from "~/lib/utils/urlHelper";
import { Topic } from "~/models/topic";

interface Props {
  isTextUnderline?: boolean;
  host?: string;
  locale?: string;
  marginBottom?: number;
  marginRight?: number;
  topic: Topic;
}

const TagTopicItem: VFC<Props> = ({
  isTextUnderline = true,
  host,
  locale,
  marginBottom,
  marginRight,
  topic,
}) => {
  if (!topic) {
    return <></>;
  }

  const topicUrl = convertToLinkHref({
    host,
    locale,
    url: pagesPath.qa._topicSlug(topic.slug).$url(),
  });

  return (
    <Link href={topicUrl} passHref>
      <Container
        dataMarginBottom={marginBottom}
        dataMarginRight={marginRight}
        isTextUnderline={isTextUnderline}
        {...externalLinkAttrs(topicUrl)}
      >
        {topic.mainImageUrl ? (
          <Image
            src={topic.mainImageUrl}
            alt={topic.name}
            width={18}
            height={18}
          />
        ) : (
          <span>&nbsp;</span>
        )}
        <Text>
          {topic.shortName ? (
            <abbr title={topic.name}>{topic.shortName}</abbr>
          ) : (
            topic.name
          )}
        </Text>
      </Container>
    </Link>
  );
};

export const Text = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Container = styled.a<{
  dataMarginBottom?: number;
  dataMarginRight?: number;
  isTextUnderline?: boolean;
}>`
  align-items: center;
  color: var(--cap-clr);
  display: inline-flex;
  border: 1px solid var(--bdr-clr);
  border-radius: 19px;
  gap: 8px;
  height: 32px;
  margin-bottom: ${(props): string =>
    props.dataMarginBottom ? `${props.dataMarginBottom}px` : "0"};
  margin-right: ${(props): string =>
    props.dataMarginRight ? `${props.dataMarginRight}px` : "0"};
  padding: 4px 16px;
  vertical-align: middle;

  ${Text} {
    text-decoration: ${(props): string =>
      props.isTextUnderline ? "underline" : "none"};
  }

  &:hover {
    opacity: 0.8;

    ${Text} {
      text-decoration: underline;
    }
  }
`;

export default TagTopicItem;
